export default __webpack_public_path__ + "images/photos.2f2912dede9c7940106defe897d3424e.svg";